<template>
  <div class="bg">
    <img src="../../static/img/470.png" alt="">
  </div>
</template>

<script>
export default {
  name: "view470",
  data() {
    return {
      "": ""
    };
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  created() {
    this.getArea();
  },
  //方法定义
  methods: {
    getArea() {
      let _this = this;
      _this.common.request("api/area", {}, function(res) {
        if (res.status == 200) {
          _this.$router.push("/");
        }
        console.log(res);
      });
    }
  }
};
</script>

<style scoped lang='less' rel="stylesheet/less">
@import "../assets/css/index.less";
.bg {
  background: #f3e8e2;
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    width: 1600px;
    height: 1200px;
    display: block;
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/view470.vue